import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @atlaskit
import { Grid, GridColumn } from '@atlaskit/page';
import { ProgressTracker } from '@atlaskit/progress-tracker';

// @source
import { Configuration, UploadTemplate, Finish } from './components';
import { Messages } from '../../components';
import { Report as API } from '../../../server';
import Layout from '../../templates/Layout';
import * as Styled from './styled';

const initialState = {
  isLoading: false,
  current: 0,
  items: [{
    id: 'configuration',
    label: 'CONFIGURATION',
    percentageComplete: 0,
    status: 'current',
  }, {
    id: 'template',
    label: 'TEMPLATE',
    percentageComplete: 0,
    status: 'unvisited',
  }, {
    id: 'finisih',
    label: 'FINISH',
    percentageComplete: 0,
    status: 'unvisited',
  }],
  message: false,
};

const initialStatic = {
  configuration: [],
  report: '',
  template: false,
};

class CreateReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.static = initialStatic;
    this.unmount = false;
    this.onSubmitHandle = this.onSubmitHandle.bind(this);
    this.setStatic = this.setStatic.bind(this);
    this.setStep = this.setStep.bind(this);
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  onSubmitHandle(callback = () => {}) {
    this.setState({ isLoading: true });
    API.create({
      data: this.static,
      dispatch: this.props.dispatch,
      success: () => {
        // this.setStep(2);
        callback();
      },
      error: (messages) => {
        this.setStateUnmount({
          isLoading: false,
          message: (
            <Messages
              items={messages}
              onClose={() => this.setState({ message: false })}
            />
          ),
        });
      },
    });
  }

  setStep(stepIndex) {
    const items = this.state.items.map((item, index) => {
      const status = index < stepIndex ? 'visited' : 'unvisited';
      return {
        ...item,
        percentageComplete: index < stepIndex ? 100 : 0,
        status: index === stepIndex ? 'current' : status,
      };
    });

    this.setState({
      current: stepIndex,
      items,
    });
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  setStatic(state) {
    this.static = { ...this.static, ...state };
  }

  render() {
    return (
      <Layout>
        <Styled.Progress>
          <Styled.ProgressContainer>
            <ProgressTracker items={this.state.items} />
          </Styled.ProgressContainer>
        </Styled.Progress>
        <Grid>
          <GridColumn>
            <Configuration
              current={this.state.current === 0}
              setStep={this.setStep}
              update={this.setStatic}
            />
            <UploadTemplate
              current={this.state.current === 1}
              isLoading={this.state.isLoading}
              save={this.onSubmitHandle}
              setStep={this.setStep}
              template={`${this.props.account.Company}_${this.static.report}`}
              update={this.setStatic}
            />
            <Finish
              current={this.state.current === 2}
            />
            {this.state.message}
          </GridColumn>
        </Grid>
      </Layout>
    );
  }
}

CreateReport.propTypes = {
  account: PropTypes.shape().isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect()(CreateReport);
